define('controllers/archive/view',[
	'jquery',
	'modules/page',
	'widgets/forward',
], function ($, page) {

	var view = {

		id: 'archive-view',
		container: '#archive > .current',

		ready: false,
		enabled: null,

		setup: function () {

			if (this.ready) return this;

			this.$win = $(window);

			this.update();

			this.ready = true;
			return this;

		},

		enable: function () {

			// this.update();

			if (this.enabled) return this;

			this.$el
				.on('click.view', '.nav a', $.proxy(this, 'onNavClick'));

			this.$win.scrollTop(0);
			this.$win.on('keydown.view', $.proxy(this, 'onKeyDown'));

			this.enabled = true;

			return this;

		},

		disable: function () {

			if (!this.enabled) return this;

			this.$el.off('.view');
			this.$win.off('.view');

			this.enabled = false;

			return this;

		},

		update: function () {

			var $el = $('#' + this.id);

			if (this.$el && this.$el[0] == $el[0])
				return;

			this.$el = $el;
			this.$overview = $('#archive-overview');

			this.setCurrent();

			return this;

		},

		setCurrent: function (id) {

			id = id || this.$el.data('id');

			if (id == this.current)
				return;

			this.current = id;
			this.$current = this.$overview.find('#email_' + this.current);

			$.publish('itemSet', id);
			console.log('set item', id);

		},

		onNavClick: function (e) {

			var $el = $(e.currentTarget);

			this.browse($el.hasClass('prev') ? 'prev' : 'next');

			e.preventDefault();

		},

		browse: function (direction) {

			var selector = '.item:not(.hidden)',
				$target, url;

			direction = direction || 'next';
			$target = this.$current[direction + 'All'](selector + ':first');

			if (!$target.length)
				$target = this.$overview.find(selector + (direction == 'next' ? ':first' : ':last'));

			url = $target.attr('href');
			if (!url) return this;

			page.load(url, 'archive-view');

			return this;

		},

		onKeyDown: function (e) {

			switch (e.keyCode) {

				case 27:
					this.$el.find('.back').trigger('click');
					break;

				case 37:
					this.$el.find('.nav .prev').trigger('click');
					break;

				case 39:
					this.$el.find('.nav .next').trigger('click');
					break;

			}

		}

	};

	return view;

});
